/* ELORIA Liver Restore page behaviour. Everything is driven by data attributes so sections stay plain HTML.
   window.ELMB_CFG = {offers:[{id,bottles,price,compare,save,price_f,compare_f}], plan, sel}
   [data-elmb-swiper='{json}']   Swiper carousel; controls looked up inside the closest [data-elmb-carousel]:
                                 .elmb-prev / .elmb-next / .elmb-dots
   [data-elmb-offer="i"]         selects offer i (class is-active on every element with the same index)
   [data-elmb-price] [data-elmb-compare] [data-elmb-save] [data-elmb-bottles]  live values of the selected offer
   [data-elmb-buy]               add the selected offer (subscription plan) to a fresh cart and go to checkout
   [data-elmb-countdown]         counts down to local midnight, children [data-h] [data-m] [data-s]
   [data-elmb-more]              toggles is-open on the closest [data-elmb-more-scope]
   [data-elmb-video]             tap to play / pause the <video> inside
   [data-elmb-acc-group]         <details> inside close each other
   [data-elmb-menu-open|close]   toggles is-open on #elmb-menu
   #elmb-sticky                  shown (is-on) once #elmb-buy-main has scrolled out above the viewport */
(function () {
  var CFG = window.ELMB_CFG || { offers: [], plan: null, sel: 1 };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* prices in the visitor's currency: strings formatted by Shopify (| money) come in ELMB_CFG as price_f / compare_f;
     without them format with Intl in Shopify's active currency, last resort the old $ format */
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var nf = null;
  try { nf = new Intl.NumberFormat('en-' + ((window.Shopify && Shopify.country) || 'US'), { style: 'currency', currency: cur }); } catch (e) {}
  var money = function (c, f) {
    if (f) { var d = document.createElement('div'); d.innerHTML = f; return d.textContent; }
    if (nf) return nf.format(c / 100);
    return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  /* ---------- carousels */
  function initSwipers() {
    if (!window.Swiper) return;
    $$('[data-elmb-swiper]').forEach(function (el) {
      if (el.swiper) return;
      var cfg = {};
      try { cfg = JSON.parse(el.getAttribute('data-elmb-swiper') || '{}'); } catch (e) {}
      var box = el.closest('[data-elmb-carousel]') || el.parentNode;
      var prev = box.querySelector('.elmb-prev'), next = box.querySelector('.elmb-next'), dots = box.querySelector('.elmb-dots');
      if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
      if (dots) cfg.pagination = { el: dots, clickable: true };
      if (cfg.thumbs) {
        var t = document.querySelector(cfg.thumbs);
        if (t && !t.swiper) new Swiper(t, JSON.parse(t.getAttribute('data-elmb-thumbs') || '{}'));
        cfg.thumbs = t ? { swiper: t.swiper } : undefined;
      }
      new Swiper(el, cfg);
    });
  }

  /* ---------- offers */
  function select(i) {
    i = Math.max(0, Math.min(CFG.offers.length - 1, +i));
    CFG.sel = i;
    var o = CFG.offers[i];
    $$('[data-elmb-offer]').forEach(function (el) {
      var on = +el.getAttribute('data-elmb-offer') === i;
      el.classList.toggle('is-active', on);
      var inp = el.querySelector('input[type=radio]');
      if (inp) inp.checked = on;
    });
    if (!o) return;
    $$('[data-elmb-price]').forEach(function (el) { el.textContent = money(o.price, o.price_f); });
    $$('[data-elmb-compare]').forEach(function (el) { el.textContent = money(o.compare, o.compare_f); });
    $$('[data-elmb-save]').forEach(function (el) { el.textContent = o.save + '%'; });
    $$('[data-elmb-bottles]').forEach(function (el) { el.textContent = o.bottles; });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-elmb-offer]');
    if (el) { e.preventDefault(); select(el.getAttribute('data-elmb-offer')); }
  });

  /* ---------- buy: fresh cart -> add with subscription plan -> checkout */
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : '{}' }).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-elmb-buy]');
    if (!b) return;
    e.preventDefault();
    if (b.closest('#elmb-sticky')) { var t = document.getElementById('elmb-offers'); if (t) { t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } return; }
    if (b.classList.contains('is-loading')) return;
    var o = CFG.offers[CFG.sel];
    if (!o) return;
    b.classList.add('is-loading');
    if (CFG.preview) { setTimeout(function () { b.classList.remove('is-loading'); }, 600); return; }
    var item = { id: o.id, quantity: 1 };
    if (CFG.plan) item.selling_plan = CFG.plan;
    post('/cart/clear.js').then(function () { return post('/cart/add.js', { items: [item] }); })
      .then(function () { if (window.phxGo) { window.phxGo('/checkout'); } else { window.location.href = '/checkout'; } })
      .catch(function () { b.classList.remove('is-loading'); if (window.phxGo) { window.phxGo('/cart'); } else { window.location.href = '/cart'; } });
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      $$('[data-elmb-buy].is-loading').forEach(function (b) { b.classList.remove('is-loading'); });
    }
  });

  /* ---------- countdown to local midnight */
  function tick() {
    var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    $$('[data-elmb-countdown]').forEach(function (el) {
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), x = el.querySelector('[data-s]');
      if (h) h.textContent = p(Math.floor(s / 3600));
      if (m) m.textContent = p(Math.floor(s % 3600 / 60));
      if (x) x.textContent = p(s % 60);
    });
  }

  /* ---------- misc */
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-elmb-more]');
    if (m) { e.preventDefault(); var sc = m.closest('[data-elmb-more-scope]'); if (sc) sc.classList.toggle('is-open'); }
    var v = e.target.closest('[data-elmb-video]');
    if (v) {
      var vid = v.querySelector('video');
      if (vid) {
        if (vid.paused) { $$('[data-elmb-video] video').forEach(function (o) { if (o !== vid) o.pause(); }); vid.controls = true; vid.play(); v.classList.add('is-playing'); }
        else if (e.target.tagName !== 'VIDEO') { vid.pause(); v.classList.remove('is-playing'); }
      }
    }
    if (e.target.closest('[data-elmb-menu-open]')) { e.preventDefault(); document.getElementById('elmb-menu').classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    if (e.target.closest('[data-elmb-menu-close]')) { e.preventDefault(); document.getElementById('elmb-menu').classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.tagName !== 'DETAILS' || !d.open) return;
    var g = d.closest('[data-elmb-acc-group]');
    if (g) $$('details[open]', g).forEach(function (o) { if (o !== d) o.open = false; });
  }, true);

  function sticky() {
    var st = document.getElementById('elmb-sticky'), b = document.getElementById('elmb-buy-main');
    if (!st || !b) return;
    var on = b.getBoundingClientRect().bottom < 0;
    st.classList.toggle('is-on', on);
  }

  /* video tiles: bring the play button back when a video stops */
  document.addEventListener('pause', function (e) {
    var t = e.target.closest && e.target.closest('[data-elmb-video]'); if (t) t.classList.remove('is-playing');
  }, true);
  document.addEventListener('ended', function (e) {
    var t = e.target.closest && e.target.closest('[data-elmb-video]'); if (t) t.classList.remove('is-playing');
  }, true);

  function start() {
    initSwipers();
    select(CFG.sel);
    tick(); setInterval(tick, 1000);
    sticky(); window.addEventListener('scroll', sticky, { passive: true });
  }
  /* theme editor re-renders one section at a time (e.g. after adding a video): set it up again */
  document.addEventListener('shopify:section:load', function () { initSwipers(); select(CFG.sel); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
